import { MobilePositionHeaderStyled } from "./styled/MobilePositionHeaderStyled";
import { createStructuredSelector } from "reselect";
import { makeSelectorGetLiteTradeAssetInfo } from "../../../../modules/LiteTrade/liteTradeSelectors";
import { connect } from "react-redux";

function MobilePositionHeader(props) {
    const {
        assetInfo,
    } = props;

    if (!assetInfo) {
        return null;
    }

    const {children} = props;
    return <MobilePositionHeaderStyled>
        <h4>{children}</h4>
        <div className="description">
            {assetInfo.info.description}
        </div>
    </MobilePositionHeaderStyled>
}

const mapStateToProps = createStructuredSelector({
    assetInfo: (state, props) => makeSelectorGetLiteTradeAssetInfo(props.symbol)(state, props)
});

export default connect(mapStateToProps)(MobilePositionHeader);
